// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { makeInitialAntennaValues } from 'redux/modules/pathDetails'

import {
  castToString,
  fromMetersToUnitType,
  roundAndCastToString,
} from 'helpers/reduxFormFunctions'

// prepare data model for an antenna set
// used for both path ends and passive repeaters.
const antennaDataForForm = (pathEnd, unitType) => {
  const { antennas } = pathEnd

  // if this path end does not have any antennas,
  // return a single empty default set of antenna values
  if (!antennas.length) {
    return [makeInitialAntennaValues(unitType)]
  }

  return antennas.reduce((a, d) => {
    const {
      antennaCode,
      antennaSpecId,
      antennaType,
      classification,
      modelNumber,
      secondSegmentEndAntennaId,
      segmentEndAntennaId,
    } = d

    const beamwidth = castToString(d.beamwidth)
    const centerline = fromMetersToUnitType(d.centerLine, unitType)
    const company = d.companyName
    const gain = castToString(d.gain)
    const mode = d.mode
    const tilt = roundAndCastToString(pathEnd.tilt, 2)

    a.push({
      antennaCode,
      antennaSpecId,
      antennaType,
      beamwidth,
      centerline,
      centerlineUnit: unitType,
      classification,
      company,
      gain,
      mode,
      modelNumber,
      secondSegmentEndAntennaId,
      segmentEndAntennaId,
      tilt,
    })
    return a
  }, [])
}

export default antennaDataForForm
